<div class="pokemon-card">
  <img [src]="pokemon().sprite" [alt]="pokemon().name" />
  <p>
    <strong>{{ pokemon().name }}</strong><br>
    <small>#{{ pokemon().pokedex_id }}</small>
  </p>

  @if (isPicked()) {
    <button class="pokemon-button" (click)="deletePokemon()">Retirer de mon équipe</button>
  } @else {
    <button class="pokemon-button" (click)="addPokemon()" [disabled]="pokemonService.pokemonPickedList().length >= 6">Ajouter à mon équipe</button>
  }
</div>